import React from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'
import Navigation from '../components/navigation'
import 'prismjs/themes/prism-okaidia.css'

export default ({ children }) => {
  const data = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
          }
        }
      }
    `
  )
  return (
    <div className="site-wrapper flex flex-col min-h-screen">
      <header className="site-header">
        <div className="site-title">
          <Link to="/">{data.site.siteMetadata.title}</Link>
        </div>
        <Navigation />
      </header>
      <main className="flex-grow">{children}</main>
      <footer className="site-footer">
        <p>
          &copy; {new Date().getFullYear()} RJ &bull; Crafted with{' '}
          <span role="img" aria-label="love">
            ❤️
          </span>{' '}
          by <a href="https://ranjithnair.dev">Ranjith Nair</a>
        </p>
      </footer>
    </div>
  )
}
